import { noteHtml, noteStyles } from './noteFormat.js';
// Render only the restricted note marks; raw student HTML is escaped.
export function printNote(title, body) {
    const popup = window.open('', '_blank', 'width=850,height=700');
    if (!popup) return false;
    const doc = popup.document;
    doc.title = title || 'My Notes';
    const style = doc.createElement('style');
    style.textContent = 'body{font:16px/1.65 system-ui,sans-serif;color:#111;background:white;margin:32px;max-width:800px}h1{font-size:24px}article{white-space:pre-wrap;overflow-wrap:anywhere}@page{margin:18mm}@media print{button{display:none}body{margin:0;max-width:none}}';
    style.textContent += noteStyles;
    doc.head.appendChild(style);
    const heading = doc.createElement('h1'); heading.textContent = title || 'My Notes';
    const article = doc.createElement('article'); article.className = 'note-rich'; article.innerHTML = noteHtml(body);
    const button = doc.createElement('button'); button.textContent = 'Print / Save as PDF'; button.onclick = () => popup.print();
    doc.body.append(button, heading, article);
    popup.opener = null;
    popup.focus(); popup.print();
    return true;
}
